import { createContext, useContext } from 'react';

const PageTitleCollapsedContext = createContext(false);

/** Whether the header has collapsed, for `titleRowActions` to render a compact form. It arrives as
 * context rather than a prop because the host hands PageTitle a finished node and cannot know the
 * template's collapse state. */
function useIsPageTitleCollapsed(): boolean {
  return useContext(PageTitleCollapsedContext);
}

export { PageTitleCollapsedContext, useIsPageTitleCollapsed };
